import { Component, ElementRef, EventEmitter, Inject, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BehaviorSubject, Observable, OperatorFunction } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, switchMap } from 'rxjs/operators';
import { DrugSearchCategoryDetails } from 'src/app/models/drug-search-category-details';
import { DrugSearchClassDetails } from 'src/app/models/drug-search-class-details';
import { DrugSearchCriteria } from 'src/app/models/drug-search-criteria';
import { PlanDetails } from 'src/app/models/plan-details';
import { ValidMatchingEntry } from 'src/app/models/valid-matching-entry';
import { DrugSearchURLService } from 'src/app/services/drug-search-url.service';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-drug-search',
  templateUrl: './drug-search.component.html',
  styleUrls: ['./drug-search.component.scss']
})
export class DrugSearchComponent implements OnInit {

  isSearchByDrug: boolean = true;
  brandOrGeneric = 'Brand or Generic*';
  brandOrGenericValue: string;
  showDrugSearchResults: boolean;
  searchByDrugNameMap = new Map();
  brandOrGenericNameList = new Array<string>();
  labelNameList = new Array<string>();
  validMatchingEntryList = new Array<ValidMatchingEntry>();
  alertMessage : string;
  @Output() errorEvent = new EventEmitter<string>();
  subs = new SubSink();
  category = "Category*";
  class = "Class*";
  planDetails = new PlanDetails();
  drugSearchCategoryDetailsList = new Array<DrugSearchCategoryDetails>();
  drugSearchCategoryDetails = new DrugSearchCategoryDetails();
  drugSearchCriteria = new DrugSearchCriteria();

  drugSearchClassDetailsList = new Array<DrugSearchClassDetails>();
  isBrandOrGeneric : String;
  noSearchResultsFound: string;
  showNoSearchResultsFound: boolean;
  displayNoFormularyDrugs: boolean;
  displayNoFormularyDrugsMessage: string;
  enableSearch:boolean = false;


  constructor(private _drugSearchURLService: DrugSearchURLService) { }

  ngOnInit(): void {
    this.planDetails = this._drugSearchURLService.planDetails;
    this.noSearchResultsFound = this._drugSearchURLService.messageKeyValueMap.get(
      'ERR00509'
    );
  }

  searchByDrugClass() {
    this.displayNoFormularyDrugs = false;
    this.planDetails.drugSearchType = "searchByDrugClass";
    this.category = "Category*";
    this.class = "Class*";
    this.isSearchByDrug = false;
    this.showDrugSearchResults = false;
    this.searchByDrugNameMap = new Map();
     this._drugSearchURLService.getTCCCategoryDetails(this.planDetails.packageId).subscribe(res=>{
      this.drugSearchCategoryDetailsList = res.data;
    })
  }

  searchByTCCClass() {
    this.showDrugSearchResults = false;
    this.showNoSearchResultsFound = false;
    this.searchByDrugNameMap = new Map();
    this.showNoSearchResultsFound = false;
    this.displayNoFormularyDrugs = false;
    this.drugSearchCriteria = new DrugSearchCriteria();
    this.drugSearchCriteria.customerSetId = this.planDetails.customerSetId;
    this.drugSearchCriteria.formularyPackageId = this.planDetails.packageId;
    this.drugSearchCriteria.formularyPackageDate = this.planDetails.lastPublicationDate;
    this.drugSearchCriteria.reasonNotPricedDisplay = this.planDetails.reasonNotPricedDisplay;
    this.drugSearchCriteria.obsoleteDrugDisplay = this.planDetails.obsoleteDrugDisplay;
    this.drugSearchCriteria.otcDrugDisplay = this.planDetails.otcDrugDisplay;
    this.drugSearchCriteria.repackagersDisplay = this.planDetails.repackagersDisplay;
    this.drugSearchCriteria.fileEventId = this.planDetails.fileEventId;
    this.drugSearchCriteria.drugListId = this.planDetails.drugListId;
    this.drugSearchCriteria.planId = this.planDetails.planId;

    this.drugSearchCriteria.groupId = this.drugSearchCategoryDetails.groupId;
    this.drugSearchCriteria.tccCategory = this.category;
    this.drugSearchCriteria.tccClass = this.class;
    this._drugSearchURLService.searchByTCCClass(this.drugSearchCriteria).subscribe(res=>{
      var len = 0;
      for (var count in res.data[0].searchByDrugNameDetailsMap) {
        len++;
        break;
      }
      if(len == 0) {
        this.displayNoFormularyDrugs = true;
        this.displayNoFormularyDrugsMessage = this.noSearchResultsFound = this._drugSearchURLService.messageKeyValueMap.get(
          'ERR00511'
        );
      } else {
      this.searchByDrugNameMap = res.data[0].searchByDrugNameDetailsMap;
      this.showDrugSearchResults = true;
      }
    })
  }

  searchByDrug() {
    this.isSearchByDrug = true;
    this.showDrugSearchResults = false;
    this.displayNoFormularyDrugs = false;
    this.searchByDrugNameMap = new Map();
    this.planDetails.drugSearchType = "searchByDrug";
    this.brandOrGenericValue = '';
  }

  onSelectionChange() {
    this.brandOrGenericValue = '';
    this.showDrugSearchResults = false;
  }

  onCategorySelectionChange() {
    for(let drugSearchCategoryDetails of this.drugSearchCategoryDetailsList) {
      if(this.category === drugSearchCategoryDetails.therCat1Nm) {
        this.drugSearchCategoryDetails = new DrugSearchCategoryDetails();
        this.drugSearchCategoryDetails = drugSearchCategoryDetails;
      }
    }
    this._drugSearchURLService.getTCCClassDetails(this.drugSearchCategoryDetails.groupId, this.drugSearchCategoryDetails.therCat1Nm).subscribe(res=>{
      this.drugSearchClassDetailsList = res.data;
    })

  }

  searchByDrugName() {
    this.showNoSearchResultsFound = false;
    this.showDrugSearchResults = false;
    this.drugSearchCriteria = new DrugSearchCriteria();
    this.displayNoFormularyDrugs = false;
    this.drugSearchCriteria.customerSetId = this.planDetails.customerSetId;
    this.drugSearchCriteria.formularyPackageId = this.planDetails.packageId;
    this.drugSearchCriteria.formularyPackageDate = this.planDetails.lastPublicationDate;
    this.drugSearchCriteria.reasonNotPricedDisplay = this.planDetails.reasonNotPricedDisplay;
    this.drugSearchCriteria.obsoleteDrugDisplay = this.planDetails.obsoleteDrugDisplay;
    this.drugSearchCriteria.repackagersDisplay = this.planDetails.repackagersDisplay;
    this.drugSearchCriteria.otcDrugDisplay = this.planDetails.otcDrugDisplay;
    this.drugSearchCriteria.fileEventId = this.planDetails.fileEventId;
    this.drugSearchCriteria.drugListId = this.planDetails.drugListId;
    this.subs.add(this._drugSearchURLService.searchByDrugName(btoa(this.brandOrGenericValue.toUpperCase())).subscribe((res) => {
      this.isBrandOrGeneric = this.brandOrGeneric;
          this.searchByDrugNameMap = new Map();
          this.brandOrGenericNameList = res.data[0].brandOrGenericNameList;
          for (let brandName of this.brandOrGenericNameList) {
            this.labelNameList = new Array<string>();
            this.labelNameList =
              res.data[0].searchByDrugNameDetailsMap[brandName];
            this.searchByDrugNameMap.set(brandName, this.labelNameList);

          }
        this.showDrugSearchResults = true;
      }));
    }

    search = (text$: Observable<string>) => {
      return text$.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      switchMap((searchText) => searchText.length < 3 ? [] :
      this._drugSearchURLService.searchDrugs(btoa(this.brandOrGenericValue.toUpperCase())))
      );
    }

    selectedItem(event) {
      this.enableSearch = true;
      this.brandOrGenericValue = event.value;
    }

    ngOnDestroy() {
      this.subs.unsubscribe();
    }

}
